import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Rx'

@Injectable()
export class Base {
    constructor() {        
    }

    handleError(error: Response) {
        return Observable.throw(error.statusText);
    }
}